export const zh = {
  zh: {
    translation: {
      confirm_app_exit: '确定登出鲨鱼宝宝儿童世界吗？',
      button_exit: '登出',
      button_cancel: '取消',
      os_update: '请更新至最新的 TV OS 版本，再重新尝试。',
      button_ok: '确认',
      t_complete_app_update: '鲨鱼宝宝儿童世界已更新。',
      error_title: '发生错误',
      error_unknown: '请关闭并重启程序。',
      error_network_title: '网络连接不稳定。',
      error_network: '请检查您的网络连接并重试。',
      button_retry: '请重试',
      confirm_continue_watching: '是否继续观看当前视频？',
      button_continue_watching: '继续观看',
      button_from_beginning: '重新播放',
      t_event_coming_soon: '活动敬请期待。',
      data_fail: '发生错误，\n请关闭并重启程序。',
      page_sign_in_header: '二维码登录',
      page_sign_in: '您需要登录后使用本服务，\n请扫描二维码进行登录。',
      page_sign_in_code: '验证码',
      page_sign_in_time: '剩余时间',
      oauth_confirm_code: '请确认与电视验证代码是否匹配',
      oauth_web_info: '网络浏览器',
      oauth_device_info: '设备访问信息',
      oauth_accept_sign_in: '接受登录',
      oauth_sign_in_success: '设备登录成功',
      oauth_sign_in_cancel: '设备登录已取消',
      oauth_sign_in_fail: '发生错误\n请扫描二维码重试',
      oauth_sign_in_expired: '登录已过期。\n请重扫电视二维码进行登录。',
      menu_my: '我的',
      menu_home: '首页',
      menu_story: '故事',
      menu_song: '儿歌',
      menu_cinema: '剧场版',
      menu_cinema_and_tv: '剧场版 & TV系列',
      menu_ip: 'IP',
      menu_topics: '主题',
      menu_home_history: '观看历史',
      title_ai_videos: 'AI精选视频',
      menu_home_new_content: '新上推荐',
      player_language_ko: '한국어',
      player_language_en: 'English',
      player_language_zh: '中文',
      player_language_pt: 'Português',
      player_language_es: 'Español',
      player_language_ja: '日本語',
      player_language_id: 'Bahasa Indonesia',
      mypage_menu_status_unsusbcribed: '暂无有效订阅',
      mypage_menu_status_susbcribed: '<span class="text-secondary">已订阅</span>碰碰狐Plus。',
      mypage_menu_benefits_unsusbcribed: '订阅福利',
      mypage_menu_benefits_susbcribed: '可享福利',
      mypage_menu_benefits_01: '2万多集原创系列动画',
      mypage_menu_benefits_02: '定期更新碰碰狐Plus独家视频',
      mypage_menu_benefits_03: '手机、电视端可同时',
      mypage_menu_benefits_04: '无限畅玩30多种互动学习应用',
      mypage_scan_to_subscribe: '扫描二维码订阅',
      mypage_video_title: '什么是 Pinkfong Plus？',
      mypage_menu_terms: '使用条款和条件',
      mypage_menu_event: '活动',
      mypage_menu_support: '服务支持',
      button_sign_out: '退出登录',
      mypage_menu_event_coming_soon: '敬请期待',
      mypage_menu_even_open: '进行中',
      terms_required_privacy: '使用条款和条件',
      terms_required_pinkfong: '服务条款',
      terms_required_interactive: '碰碰狐互动应用条款',
      mypage_menu_device_info: '设备信息',
      page_device_info: '请提供以下信息帮助我们迅速为您解决问题。',
      page_device_info_model: '设备型号',
      page_device_info_os: '操作系统平台',
      page_device_info_version: '应用版本',
      page_support: '如需服务与帮助，请发邮件至。 cs@pinkfong.com',
      caution_sign_out: '退出登录后将限制服务使用。',
      topic_category_all: 'All',
      player_language_button: '语言',
    },
  },
};
